
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * BotAccessServerSettings struct
 */
class BotAccessServerSettings {
  /**
   * Initialize struct
   * @param {!boolean=} apiEndpointEnabled
   * @param {!number=} apiPort
   * @param {!boolean=} eventsEndpointEnabled
   * @param {!number=} eventsPort
   * @param {!boolean=} docsEnabled
   * @param {!string=} wwwPath
   * @param {!string=} docsPrefix
   * @param {!string=} sslCertificatePath
   * @param {string=} sslCertificatePassword
   * @param {!number=} clientNotifySendingIntervalMs
   * @param {!number=} httpTimeoutSeconds
   * @param {!number=} httpBodyLimitBytes
   * @param {!number=} httpInProcessRequestsLimit
   * @param {!number=} websocketQueueLimit
   * @param {!number=} websocketBodyLimitBytes
   * @param {!number=} websocketOpTimeoutSeconds
   * @param {!number=} websocketPingTimeoutSeconds
   * @param {!UUID=} securitySettingsId
   * @constructor
   */
  constructor (apiEndpointEnabled = true, apiPort = 6530, eventsEndpointEnabled = true, eventsPort = 6420, docsEnabled = false, wwwPath = '../www/api/trading', docsPrefix = '/api-docs', sslCertificatePath = '../tools/certificates/server.pem', sslCertificatePassword = '', clientNotifySendingIntervalMs = 500, httpTimeoutSeconds = 30, httpBodyLimitBytes = 1000, httpInProcessRequestsLimit = 16, websocketQueueLimit = 128, websocketBodyLimitBytes = 1000, websocketOpTimeoutSeconds = 30, websocketPingTimeoutSeconds = 30, securitySettingsId = new UUID()) {
    this.ApiEndpointEnabled = apiEndpointEnabled
    this.ApiPort = apiPort
    this.EventsEndpointEnabled = eventsEndpointEnabled
    this.EventsPort = eventsPort
    this.DocsEnabled = docsEnabled
    this.WwwPath = wwwPath
    this.DocsPrefix = docsPrefix
    this.SslCertificatePath = sslCertificatePath
    this.SslCertificatePassword = sslCertificatePassword
    this.ClientNotifySendingIntervalMs = clientNotifySendingIntervalMs
    this.HttpTimeoutSeconds = httpTimeoutSeconds
    this.HttpBodyLimitBytes = httpBodyLimitBytes
    this.HttpInProcessRequestsLimit = httpInProcessRequestsLimit
    this.WebsocketQueueLimit = websocketQueueLimit
    this.WebsocketBodyLimitBytes = websocketBodyLimitBytes
    this.WebsocketOpTimeoutSeconds = websocketOpTimeoutSeconds
    this.WebsocketPingTimeoutSeconds = websocketPingTimeoutSeconds
    this.SecuritySettingsId = securitySettingsId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!BotAccessServerSettings}
   * @param {!BotAccessServerSettings} other Other struct
   * @returns {!BotAccessServerSettings} This struct
   */
  copy (other) {
    if (other.ApiEndpointEnabled != null) {
      this.ApiEndpointEnabled = other.ApiEndpointEnabled
    } else {
      this.ApiEndpointEnabled = null
    }
    if (other.ApiPort != null) {
      this.ApiPort = other.ApiPort
    } else {
      this.ApiPort = null
    }
    if (other.EventsEndpointEnabled != null) {
      this.EventsEndpointEnabled = other.EventsEndpointEnabled
    } else {
      this.EventsEndpointEnabled = null
    }
    if (other.EventsPort != null) {
      this.EventsPort = other.EventsPort
    } else {
      this.EventsPort = null
    }
    if (other.DocsEnabled != null) {
      this.DocsEnabled = other.DocsEnabled
    } else {
      this.DocsEnabled = null
    }
    if (other.WwwPath != null) {
      this.WwwPath = other.WwwPath
    } else {
      this.WwwPath = null
    }
    if (other.DocsPrefix != null) {
      this.DocsPrefix = other.DocsPrefix
    } else {
      this.DocsPrefix = null
    }
    if (other.SslCertificatePath != null) {
      this.SslCertificatePath = other.SslCertificatePath
    } else {
      this.SslCertificatePath = null
    }
    if (other.SslCertificatePassword != null) {
      this.SslCertificatePassword = other.SslCertificatePassword
    } else {
      this.SslCertificatePassword = null
    }
    if (other.ClientNotifySendingIntervalMs != null) {
      this.ClientNotifySendingIntervalMs = other.ClientNotifySendingIntervalMs
    } else {
      this.ClientNotifySendingIntervalMs = null
    }
    if (other.HttpTimeoutSeconds != null) {
      this.HttpTimeoutSeconds = other.HttpTimeoutSeconds
    } else {
      this.HttpTimeoutSeconds = null
    }
    if (other.HttpBodyLimitBytes != null) {
      this.HttpBodyLimitBytes = other.HttpBodyLimitBytes
    } else {
      this.HttpBodyLimitBytes = null
    }
    if (other.HttpInProcessRequestsLimit != null) {
      this.HttpInProcessRequestsLimit = other.HttpInProcessRequestsLimit
    } else {
      this.HttpInProcessRequestsLimit = null
    }
    if (other.WebsocketQueueLimit != null) {
      this.WebsocketQueueLimit = other.WebsocketQueueLimit
    } else {
      this.WebsocketQueueLimit = null
    }
    if (other.WebsocketBodyLimitBytes != null) {
      this.WebsocketBodyLimitBytes = other.WebsocketBodyLimitBytes
    } else {
      this.WebsocketBodyLimitBytes = null
    }
    if (other.WebsocketOpTimeoutSeconds != null) {
      this.WebsocketOpTimeoutSeconds = other.WebsocketOpTimeoutSeconds
    } else {
      this.WebsocketOpTimeoutSeconds = null
    }
    if (other.WebsocketPingTimeoutSeconds != null) {
      this.WebsocketPingTimeoutSeconds = other.WebsocketPingTimeoutSeconds
    } else {
      this.WebsocketPingTimeoutSeconds = null
    }
    if (other.SecuritySettingsId != null) {
      this.SecuritySettingsId = new UUID(other.SecuritySettingsId)
    } else {
      this.SecuritySettingsId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!BotAccessServerSettings}
   * @returns {!BotAccessServerSettings} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new BotAccessServerSettingsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new BotAccessServerSettingsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!BotAccessServerSettings}
   * @param {!BotAccessServerSettings} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BotAccessServerSettings)) {
      throw new TypeError('Instance of BotAccessServerSettings is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!BotAccessServerSettings}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      ApiEndpointEnabled: ((this.ApiEndpointEnabled != null) ? this.ApiEndpointEnabled : null),
      ApiPort: ((this.ApiPort != null) ? this.ApiPort : null),
      EventsEndpointEnabled: ((this.EventsEndpointEnabled != null) ? this.EventsEndpointEnabled : null),
      EventsPort: ((this.EventsPort != null) ? this.EventsPort : null),
      DocsEnabled: ((this.DocsEnabled != null) ? this.DocsEnabled : null),
      WwwPath: ((this.WwwPath != null) ? this.WwwPath : null),
      DocsPrefix: ((this.DocsPrefix != null) ? this.DocsPrefix : null),
      SslCertificatePath: ((this.SslCertificatePath != null) ? this.SslCertificatePath : null),
      SslCertificatePassword: ((this.SslCertificatePassword != null) ? this.SslCertificatePassword : null),
      ClientNotifySendingIntervalMs: ((this.ClientNotifySendingIntervalMs != null) ? this.ClientNotifySendingIntervalMs : null),
      HttpTimeoutSeconds: ((this.HttpTimeoutSeconds != null) ? this.HttpTimeoutSeconds : null),
      HttpBodyLimitBytes: ((this.HttpBodyLimitBytes != null) ? this.HttpBodyLimitBytes : null),
      HttpInProcessRequestsLimit: ((this.HttpInProcessRequestsLimit != null) ? this.HttpInProcessRequestsLimit : null),
      WebsocketQueueLimit: ((this.WebsocketQueueLimit != null) ? this.WebsocketQueueLimit : null),
      WebsocketBodyLimitBytes: ((this.WebsocketBodyLimitBytes != null) ? this.WebsocketBodyLimitBytes : null),
      WebsocketOpTimeoutSeconds: ((this.WebsocketOpTimeoutSeconds != null) ? this.WebsocketOpTimeoutSeconds : null),
      WebsocketPingTimeoutSeconds: ((this.WebsocketPingTimeoutSeconds != null) ? this.WebsocketPingTimeoutSeconds : null),
      SecuritySettingsId: ((this.SecuritySettingsId != null) ? this.SecuritySettingsId.toString() : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return BotAccessServerSettings.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!BotAccessServerSettings} other Object value
   * @returns {!BotAccessServerSettings} Created struct
   */
  static fromObject (other) {
    return new BotAccessServerSettings().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!BotAccessServerSettings}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return BotAccessServerSettings.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!BotAccessServerSettings}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 218
  }
}

export { BotAccessServerSettings };

/**
 * Fast Binary Encoding BotAccessServerSettings field model
 */
class FieldModelBotAccessServerSettings extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.ApiEndpointEnabled = new fbe.FieldModelBool(buffer, 4 + 4)
    this.ApiPort = new fbe.FieldModelUInt16(buffer, this.ApiEndpointEnabled.fbeOffset + this.ApiEndpointEnabled.fbeSize)
    this.EventsEndpointEnabled = new fbe.FieldModelBool(buffer, this.ApiPort.fbeOffset + this.ApiPort.fbeSize)
    this.EventsPort = new fbe.FieldModelUInt16(buffer, this.EventsEndpointEnabled.fbeOffset + this.EventsEndpointEnabled.fbeSize)
    this.DocsEnabled = new fbe.FieldModelBool(buffer, this.EventsPort.fbeOffset + this.EventsPort.fbeSize)
    this.WwwPath = new fbe.FieldModelString(buffer, this.DocsEnabled.fbeOffset + this.DocsEnabled.fbeSize)
    this.DocsPrefix = new fbe.FieldModelString(buffer, this.WwwPath.fbeOffset + this.WwwPath.fbeSize)
    this.SslCertificatePath = new fbe.FieldModelString(buffer, this.DocsPrefix.fbeOffset + this.DocsPrefix.fbeSize)
    this.SslCertificatePassword = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.SslCertificatePath.fbeOffset + this.SslCertificatePath.fbeSize), buffer, this.SslCertificatePath.fbeOffset + this.SslCertificatePath.fbeSize)
    this.ClientNotifySendingIntervalMs = new fbe.FieldModelUInt32(buffer, this.SslCertificatePassword.fbeOffset + this.SslCertificatePassword.fbeSize)
    this.HttpTimeoutSeconds = new fbe.FieldModelUInt32(buffer, this.ClientNotifySendingIntervalMs.fbeOffset + this.ClientNotifySendingIntervalMs.fbeSize)
    this.HttpBodyLimitBytes = new fbe.FieldModelUInt32(buffer, this.HttpTimeoutSeconds.fbeOffset + this.HttpTimeoutSeconds.fbeSize)
    this.HttpInProcessRequestsLimit = new fbe.FieldModelUInt32(buffer, this.HttpBodyLimitBytes.fbeOffset + this.HttpBodyLimitBytes.fbeSize)
    this.WebsocketQueueLimit = new fbe.FieldModelUInt32(buffer, this.HttpInProcessRequestsLimit.fbeOffset + this.HttpInProcessRequestsLimit.fbeSize)
    this.WebsocketBodyLimitBytes = new fbe.FieldModelUInt32(buffer, this.WebsocketQueueLimit.fbeOffset + this.WebsocketQueueLimit.fbeSize)
    this.WebsocketOpTimeoutSeconds = new fbe.FieldModelUInt32(buffer, this.WebsocketBodyLimitBytes.fbeOffset + this.WebsocketBodyLimitBytes.fbeSize)
    this.WebsocketPingTimeoutSeconds = new fbe.FieldModelUInt32(buffer, this.WebsocketOpTimeoutSeconds.fbeOffset + this.WebsocketOpTimeoutSeconds.fbeSize)
    this.SecuritySettingsId = new fbe.FieldModelUUID(buffer, this.WebsocketPingTimeoutSeconds.fbeOffset + this.WebsocketPingTimeoutSeconds.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.ApiEndpointEnabled.fbeSize + this.ApiPort.fbeSize + this.EventsEndpointEnabled.fbeSize + this.EventsPort.fbeSize + this.DocsEnabled.fbeSize + this.WwwPath.fbeSize + this.DocsPrefix.fbeSize + this.SslCertificatePath.fbeSize + this.SslCertificatePassword.fbeSize + this.ClientNotifySendingIntervalMs.fbeSize + this.HttpTimeoutSeconds.fbeSize + this.HttpBodyLimitBytes.fbeSize + this.HttpInProcessRequestsLimit.fbeSize + this.WebsocketQueueLimit.fbeSize + this.WebsocketBodyLimitBytes.fbeSize + this.WebsocketOpTimeoutSeconds.fbeSize + this.WebsocketPingTimeoutSeconds.fbeSize + this.SecuritySettingsId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.ApiEndpointEnabled.fbeExtra + this.ApiPort.fbeExtra + this.EventsEndpointEnabled.fbeExtra + this.EventsPort.fbeExtra + this.DocsEnabled.fbeExtra + this.WwwPath.fbeExtra + this.DocsPrefix.fbeExtra + this.SslCertificatePath.fbeExtra + this.SslCertificatePassword.fbeExtra + this.ClientNotifySendingIntervalMs.fbeExtra + this.HttpTimeoutSeconds.fbeExtra + this.HttpBodyLimitBytes.fbeExtra + this.HttpInProcessRequestsLimit.fbeExtra + this.WebsocketQueueLimit.fbeExtra + this.WebsocketBodyLimitBytes.fbeExtra + this.WebsocketOpTimeoutSeconds.fbeExtra + this.WebsocketPingTimeoutSeconds.fbeExtra + this.SecuritySettingsId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelBotAccessServerSettings.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 218
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.ApiEndpointEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ApiEndpointEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ApiEndpointEnabled.fbeSize

    if ((fbeCurrentSize + this.ApiPort.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ApiPort.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ApiPort.fbeSize

    if ((fbeCurrentSize + this.EventsEndpointEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.EventsEndpointEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.EventsEndpointEnabled.fbeSize

    if ((fbeCurrentSize + this.EventsPort.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.EventsPort.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.EventsPort.fbeSize

    if ((fbeCurrentSize + this.DocsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DocsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DocsEnabled.fbeSize

    if ((fbeCurrentSize + this.WwwPath.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.WwwPath.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WwwPath.fbeSize

    if ((fbeCurrentSize + this.DocsPrefix.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DocsPrefix.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DocsPrefix.fbeSize

    if ((fbeCurrentSize + this.SslCertificatePath.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SslCertificatePath.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SslCertificatePath.fbeSize

    if ((fbeCurrentSize + this.SslCertificatePassword.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SslCertificatePassword.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SslCertificatePassword.fbeSize

    if ((fbeCurrentSize + this.ClientNotifySendingIntervalMs.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientNotifySendingIntervalMs.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientNotifySendingIntervalMs.fbeSize

    if ((fbeCurrentSize + this.HttpTimeoutSeconds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.HttpTimeoutSeconds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.HttpBodyLimitBytes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.HttpBodyLimitBytes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpBodyLimitBytes.fbeSize

    if ((fbeCurrentSize + this.HttpInProcessRequestsLimit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.HttpInProcessRequestsLimit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpInProcessRequestsLimit.fbeSize

    if ((fbeCurrentSize + this.WebsocketQueueLimit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.WebsocketQueueLimit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketQueueLimit.fbeSize

    if ((fbeCurrentSize + this.WebsocketBodyLimitBytes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.WebsocketBodyLimitBytes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketBodyLimitBytes.fbeSize

    if ((fbeCurrentSize + this.WebsocketOpTimeoutSeconds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.WebsocketOpTimeoutSeconds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketOpTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.WebsocketPingTimeoutSeconds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.WebsocketPingTimeoutSeconds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketPingTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.SecuritySettingsId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SecuritySettingsId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SecuritySettingsId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!BotAccessServerSettings} fbeValue Default value, defaults is new BotAccessServerSettings()
   * @returns {!BotAccessServerSettings} BotAccessServerSettings value
   */
  get (fbeValue = new BotAccessServerSettings()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!BotAccessServerSettings} fbeValue BotAccessServerSettings value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.ApiEndpointEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.ApiEndpointEnabled = this.ApiEndpointEnabled.get(true)
    } else {
      fbeValue.ApiEndpointEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ApiEndpointEnabled.fbeSize

    if ((fbeCurrentSize + this.ApiPort.fbeSize) <= fbeStructSize) {
      fbeValue.ApiPort = this.ApiPort.get(6530)
    } else {
      fbeValue.ApiPort = 6530
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ApiPort.fbeSize

    if ((fbeCurrentSize + this.EventsEndpointEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.EventsEndpointEnabled = this.EventsEndpointEnabled.get(true)
    } else {
      fbeValue.EventsEndpointEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.EventsEndpointEnabled.fbeSize

    if ((fbeCurrentSize + this.EventsPort.fbeSize) <= fbeStructSize) {
      fbeValue.EventsPort = this.EventsPort.get(6420)
    } else {
      fbeValue.EventsPort = 6420
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.EventsPort.fbeSize

    if ((fbeCurrentSize + this.DocsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.DocsEnabled = this.DocsEnabled.get(false)
    } else {
      fbeValue.DocsEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DocsEnabled.fbeSize

    if ((fbeCurrentSize + this.WwwPath.fbeSize) <= fbeStructSize) {
      fbeValue.WwwPath = this.WwwPath.get('../www/api/trading')
    } else {
      fbeValue.WwwPath = '../www/api/trading'
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WwwPath.fbeSize

    if ((fbeCurrentSize + this.DocsPrefix.fbeSize) <= fbeStructSize) {
      fbeValue.DocsPrefix = this.DocsPrefix.get('/api-docs')
    } else {
      fbeValue.DocsPrefix = '/api-docs'
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DocsPrefix.fbeSize

    if ((fbeCurrentSize + this.SslCertificatePath.fbeSize) <= fbeStructSize) {
      fbeValue.SslCertificatePath = this.SslCertificatePath.get('../tools/certificates/server.pem')
    } else {
      fbeValue.SslCertificatePath = '../tools/certificates/server.pem'
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SslCertificatePath.fbeSize

    if ((fbeCurrentSize + this.SslCertificatePassword.fbeSize) <= fbeStructSize) {
      fbeValue.SslCertificatePassword = this.SslCertificatePassword.get('')
    } else {
      fbeValue.SslCertificatePassword = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SslCertificatePassword.fbeSize

    if ((fbeCurrentSize + this.ClientNotifySendingIntervalMs.fbeSize) <= fbeStructSize) {
      fbeValue.ClientNotifySendingIntervalMs = this.ClientNotifySendingIntervalMs.get(500)
    } else {
      fbeValue.ClientNotifySendingIntervalMs = 500
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientNotifySendingIntervalMs.fbeSize

    if ((fbeCurrentSize + this.HttpTimeoutSeconds.fbeSize) <= fbeStructSize) {
      fbeValue.HttpTimeoutSeconds = this.HttpTimeoutSeconds.get(30)
    } else {
      fbeValue.HttpTimeoutSeconds = 30
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.HttpBodyLimitBytes.fbeSize) <= fbeStructSize) {
      fbeValue.HttpBodyLimitBytes = this.HttpBodyLimitBytes.get(1000)
    } else {
      fbeValue.HttpBodyLimitBytes = 1000
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpBodyLimitBytes.fbeSize

    if ((fbeCurrentSize + this.HttpInProcessRequestsLimit.fbeSize) <= fbeStructSize) {
      fbeValue.HttpInProcessRequestsLimit = this.HttpInProcessRequestsLimit.get(16)
    } else {
      fbeValue.HttpInProcessRequestsLimit = 16
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HttpInProcessRequestsLimit.fbeSize

    if ((fbeCurrentSize + this.WebsocketQueueLimit.fbeSize) <= fbeStructSize) {
      fbeValue.WebsocketQueueLimit = this.WebsocketQueueLimit.get(128)
    } else {
      fbeValue.WebsocketQueueLimit = 128
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketQueueLimit.fbeSize

    if ((fbeCurrentSize + this.WebsocketBodyLimitBytes.fbeSize) <= fbeStructSize) {
      fbeValue.WebsocketBodyLimitBytes = this.WebsocketBodyLimitBytes.get(1000)
    } else {
      fbeValue.WebsocketBodyLimitBytes = 1000
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketBodyLimitBytes.fbeSize

    if ((fbeCurrentSize + this.WebsocketOpTimeoutSeconds.fbeSize) <= fbeStructSize) {
      fbeValue.WebsocketOpTimeoutSeconds = this.WebsocketOpTimeoutSeconds.get(30)
    } else {
      fbeValue.WebsocketOpTimeoutSeconds = 30
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketOpTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.WebsocketPingTimeoutSeconds.fbeSize) <= fbeStructSize) {
      fbeValue.WebsocketPingTimeoutSeconds = this.WebsocketPingTimeoutSeconds.get(30)
    } else {
      fbeValue.WebsocketPingTimeoutSeconds = 30
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.WebsocketPingTimeoutSeconds.fbeSize

    if ((fbeCurrentSize + this.SecuritySettingsId.fbeSize) <= fbeStructSize) {
      fbeValue.SecuritySettingsId = this.SecuritySettingsId.get()
    } else {
      fbeValue.SecuritySettingsId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SecuritySettingsId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelBotAccessServerSettings}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelBotAccessServerSettings}
   * @param {!BotAccessServerSettings} fbeValue BotAccessServerSettings value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelBotAccessServerSettings}
   * @param {BotAccessServerSettings} fbeValue BotAccessServerSettings value
   */
  setFields (fbeValue) {
    this.ApiEndpointEnabled.set(fbeValue.ApiEndpointEnabled)
    this.ApiPort.set(fbeValue.ApiPort)
    this.EventsEndpointEnabled.set(fbeValue.EventsEndpointEnabled)
    this.EventsPort.set(fbeValue.EventsPort)
    this.DocsEnabled.set(fbeValue.DocsEnabled)
    this.WwwPath.set(fbeValue.WwwPath)
    this.DocsPrefix.set(fbeValue.DocsPrefix)
    this.SslCertificatePath.set(fbeValue.SslCertificatePath)
    this.SslCertificatePassword.set(fbeValue.SslCertificatePassword)
    this.ClientNotifySendingIntervalMs.set(fbeValue.ClientNotifySendingIntervalMs)
    this.HttpTimeoutSeconds.set(fbeValue.HttpTimeoutSeconds)
    this.HttpBodyLimitBytes.set(fbeValue.HttpBodyLimitBytes)
    this.HttpInProcessRequestsLimit.set(fbeValue.HttpInProcessRequestsLimit)
    this.WebsocketQueueLimit.set(fbeValue.WebsocketQueueLimit)
    this.WebsocketBodyLimitBytes.set(fbeValue.WebsocketBodyLimitBytes)
    this.WebsocketOpTimeoutSeconds.set(fbeValue.WebsocketOpTimeoutSeconds)
    this.WebsocketPingTimeoutSeconds.set(fbeValue.WebsocketPingTimeoutSeconds)
    this.SecuritySettingsId.set(fbeValue.SecuritySettingsId)
  }
}

export { FieldModelBotAccessServerSettings };

/**
 * Fast Binary Encoding BotAccessServerSettings model
 */
class BotAccessServerSettingsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelBotAccessServerSettings(this.buffer, 4)
  }

  /**
   * Get the BotAccessServerSettings model
   * @this {!BotAccessServerSettingsModel}
   * @returns {!FieldModelBotAccessServerSettings} model BotAccessServerSettings model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!BotAccessServerSettingsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!BotAccessServerSettingsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return BotAccessServerSettingsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!BotAccessServerSettingsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelBotAccessServerSettings.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!BotAccessServerSettingsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!BotAccessServerSettingsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!BotAccessServerSettingsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!BotAccessServerSettingsModel}
   * @param {!BotAccessServerSettings} value BotAccessServerSettings value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!BotAccessServerSettingsModel}
   * @param {!BotAccessServerSettings} value BotAccessServerSettings value, defaults is new BotAccessServerSettings()
   * @return {!object} Deserialized BotAccessServerSettings value and its size
   */
  deserialize (value = new BotAccessServerSettings()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new BotAccessServerSettings(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new BotAccessServerSettings(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!BotAccessServerSettingsModel}
   * @param {!number} prev Previous BotAccessServerSettings model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { BotAccessServerSettingsModel };
